import type { CSSProperties, FC } from 'react';

import classNames from 'classnames';

import { selectIncompleteTransferJobByObjectId } from '@iconik-io/shared-lib/src/redux/selectors/jobs/selectors';

import {
  JOB_COMPLETED_STATUSES_SET,
  JOB_STATUS_FAILED,
  JOB_STATUS_WAITING,
} from '../../../constants/jobs';
import { useAppSelector } from '../../../store/react_redux_typed';

import styles from './search_item_progress.module.css';

type Props = {
  id: string;
};

const SearchItemProgress: FC<Props> = (props) => {
  const job = useAppSelector((state) =>
    selectIncompleteTransferJobByObjectId(state, props.id),
  );
  if (!job) {
    return null;
  }

  let style: CSSProperties | undefined;
  if (job.progress) {
    style = {
      width: `${job.progress}%`,
    };

    if (job.progress === 0) {
      style.transition = 'none';
    }

    if (job.progress >= 100) {
      style.opacity = 0;
    }
  }

  return (
    <div
      style={style}
      className={classNames(styles.progress_line, {
        [styles.hidden]:
          JOB_COMPLETED_STATUSES_SET.has(job.status) &&
          job.status !== JOB_STATUS_FAILED,
        [styles.error]: job.status === JOB_STATUS_FAILED,
        [styles.queued]: job.status === JOB_STATUS_WAITING,
      })}
    />
  );
};

export default SearchItemProgress;
